import React, { useState } from 'react';
import { Button, Menu, MenuItem, TextField, useTheme } from '@mui/material';
import { tokens } from '../../theme';

const AvailableMethods = ({ items, onSelect }) => {

	const theme = useTheme();
	const colors = tokens(theme.palette.mode);

	const [anchorEl, setAnchorEl] = useState(null);
	const [searchText, setSearchText] = useState('');

	const handleClick = (event) => {
		setAnchorEl(event.currentTarget);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	const handleSelect = (item) => {
		onSelect(item);
		handleClose();
	};

	const filteredItems = items.filter((item) =>
		item.toLowerCase().includes(searchText.toLowerCase())
	);

	return (
		<>
			<Button
				color='inherit'
				style={{ color: colors.grey[100] }}
				onClick={handleClick}
			>
				Available Methods
			</Button>
			<Menu
				anchorEl={anchorEl}
				open={Boolean(anchorEl)}
				onClose={handleClose}
				sx={{
					'& .MuiMenu-paper': {
						marginTop: '8px',
						background: colors.primary[400],
					},
				}}
			>
				<TextField
					label='Search'
					variant='outlined'
					value={searchText}
					onChange={(e) => setSearchText(e.target.value)}
					onClick={(e) => e.stopPropagation()}
					onKeyDown={(e) => e.stopPropagation()}
					fullWidth
					sx={{ marginBottom: '8px' }}
				/>
				{filteredItems.map((item) => (
					<MenuItem
						key={item}
						onClick={() => handleSelect(item)}
						sx={{
							'&:hover': {
								backgroundColor: colors.primary[500],
							},
						}}
					>
						{item}
					</MenuItem>
				))}
			</Menu>
		</>
	);
};

export default AvailableMethods;
